import { Button } from '#app/components/Buttons/Button.js';
import { Text } from '#app/components/Primitives/Text.js';
import { BlackStarIcon } from './AverageCompanyReviewScoreBreakdown.js';
import { ChevronDownIcon, ChevronUpIcon } from '@contra/icons/icons';
import { ReactNode } from 'react';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0;
`;

const TopRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
`;

const StyledText = styled(Text).attrs({
  color: 'black',
  textStyle: 'subtitleSmall',
})`
  font-weight: 600;
`;

const BottomRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const CollapsibleOtherReviews = ({
  avatarGroup,
  children,
  isOpen,
  label,
  onClickClose,
  onClickOpen,
}: {
  readonly avatarGroup: ReactNode;
  readonly children: ReactNode;
  readonly isOpen: boolean;
  readonly label: string;
  readonly onClickClose: () => void;
  readonly onClickOpen: () => void;
}) => {
  return (
    <Container>
      <TopRow>
        <BlackStarIcon />
        <StyledText>{label}</StyledText>
      </TopRow>
      <BottomRow>
        {avatarGroup}
        <Button
          icon={isOpen ? ChevronUpIcon : ChevronDownIcon}
          iconPlacement="right"
          onClick={isOpen ? onClickClose : onClickOpen}
          size="small"
          variant="V2Link"
        >
          {isOpen ? 'Hide other reviews' : 'View other reviews'}
        </Button>
      </BottomRow>
      {isOpen && children}
    </Container>
  );
};
